import { makeStyles } from "@material-ui/core";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    // paddingTop: theme.spacing(8),
    "& .MuiDivider-root": {
      marginBottom: theme.spacing(4),
    },
  },
  itemNav: {
    "&.Mui-selected": {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: "#fff !important",
      borderRadius: 6
    },
    "&:hover": {
      color: theme.palette.primary.main
    },
    "& + &": {
      marginTop: 4
    }
  },
  tabContainer: {
    backgroundColor: "#fff",
    width: 240,
    height: "calc(100vh - 64px - 48px)",
    padding: 16
  },
  drawerPaper: {
    width: drawerWidth,
    position: "fixed",
    top: theme.spacing(8),
    zIndex: "1",
    borderRight: "none",
  },
  content: {
    flexGrow: 1,
    boxSizing: "border-box",
    padding: theme.spacing(3),
    // marginTop: theme.spacing(5),
    width: `calc( 100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  titleSection: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "24px !important",
    marginTop: "32px !important",
    "& h4": {
      marginRight: "16px !important",
    },
  },
  searchTitle: {
    marginBottom: theme.spacing(2),
  },
  createCompanyBtn: {
    marginTop: 0,
    // marginTop: theme.spacing(4),
    // marginBottom: theme.spacing(4),
  },
  companyTreeHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  companyTreeAction: {
    display: "flex",
    justifyContent: "space-between",
  },
  // companyTreeTitle: {
  //   marginBottom: theme.spacing(2),
  // },
  companyTreeContent: {
    //padding: '24px !important',
  },
  treeOuter: {
    maxHeight: "400px",
    minHeight: "400px",
  },
  popupIndicatorOpen: {
    display: "none",
  },
  popupIndicator: {
    display: "none",
  },
  searchInput: {
    position: "relative",
    width: 342,
    marginRight: theme.spacing(2),
    // width: '40vw !important',
    //  marginBottom: 36,
    "& .MuiFormControl-root": {
      width: "100% !important",
    },
  },
  searchIcon: {
    position: "absolute",
    top: 10,
    right: 12,
  },
  clearIndicator: {
    right: 46,
  },
  customInput: {
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px",
    },
    "& .MuiInputLabel-formControl:not(& .MuiInputLabel-outlined.MuiInputLabel-shrink)":
      {
        top: -7,
      },
  },
  groupWrapper: {
    display: "flex",
    flex: 1,
    width: "100%",
    height: "100%",
    minWidth: 0,
    minHeight: 0
  },
  sizableGroupWrapper: {
    height: "100% !important",
    marginRight: 20,
    flex: "none",
    overflow: "hidden"
  },
  sizableGroupList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto"
  },
  sizablePaper: {
    height: "100%"
  },
  announcementList: {
    padding: '20px',
    width: '100%',
    height: '100%',
    overflow: "auto"
  },
  announcementContent: {
    padding: '20px',
    width: '100%',
    height: '100%',
    overflow: "auto"
  },
  contentSection: {
    margin: 10,
    width: 'calc(100% - 20px)',
    height: 'calc(100% - 20px)',
    overflow: "auto",
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: 10
  },
  contentTitleSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 40,
    "& h5": {
      marginRight: "16px !important",
    },
  },
  announcementConfig: {
    padding: '15px 15px 1px',
    borderRadius: 10,
    backgroundColor: '#f1f1f1',
    display: 'flex',
    flexWrap: 'wrap',

    '& .ant-form-item': {
      width: '50%',
    }
  }
}));

export default useStyles;
